module.exports = __webpack_public_path__ + "assets/img/Kaplan-Professional-Pillar-Page-Resource-w540.2af4fc9c.webp";